const Contact = ({ txt }) => {
  const toggleModal = (e) => {
    const backdrop = document.querySelector('.backdrop');
    backdrop.click();
  };

  return (
    <>
      <div className="contact-modal__top">
        <h3>
          <span className="btn-inner--text">Contact Us</span>
        </h3>
        <span className="contact-close" onClick={toggleModal}>
          x
        </span>
      </div>
      <div className="contact-modal__bottom">
        <p>{txt}</p>
        <div className="contact-modal__bottom--btns">
          <a
            className="contact-modal__btn whatsapp"
            href="https://api.whatsapp.com/send?phone=+905553053293&text=Hello TIP team!, "
            target="_blank"
            rel="noreferrer"
          >
            <span>Chat on Whatsapp</span>
          </a>
          <a
            className="contact-modal__btn email"
            href="mailto:info@turkeyinvestmentproperty.com"
            target="_blank"
            rel="noreferrer"
          >
            <span>Send Email</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default Contact;
